import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const deleteLanguage = id => {
  return dispatch => {
    dispatch({ type: "DELETE_LANGUAGE_LOADING" });
    api
      .languageDelete(id)
      .then(resp => {
        dispatch(operationSucceeded(id));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteLanguageErrorAlertTitle",
          "Virhe poistaessa kielitaitoa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (id) => ({
  type: "DELETE_LANGUAGE_SUCCEEDED",
  payload: { language: { languageId: id, rowId: id } }
});

const operationFail = () => ({
  type: "DELETE_LANGUAGE_FAIL"
});
